import { Images } from "../Components/Images";
import config from "./index";

export const ONEDAYINSECONDS = 86400;

export const BURN = "0x000000000000000000000000000000000000dEaD";
export const ZERO_ADDRESS = "0x0000000000000000000000000000000000000000";

export const BLOCKS_PER_YEAR = 10512000;

export const PROJECT_ID = "b8a1daa2dd22335a2fe1d2e139980ae0";

export const SOCKET_URL = config.API_URL;


// export const BUYCONTRACTADDRESS = "0x9521894e01D84e098329c22F2f283FF13396FA0d"
export const BUYCONTRACTABI = [{ "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "from", "type": "address" }, { "indexed": true, "internalType": "address", "name": "to", "type": "address" }], "name": "OwnershipTransferred", "type": "event" }, { "inputs": [{ "internalType": "string", "name": "subId", "type": "string" }, { "internalType": "string", "name": "name", "type": "string" }, { "internalType": "uint256", "name": "flashloanLimit", "type": "uint256" }, { "internalType": "uint256", "name": "feeAmount", "type": "uint256" }, { "internalType": "uint256", "name": "profitMax", "type": "uint256" }, { "internalType": "address", "name": "acceptedToken", "type": "address" }, { "internalType": "uint256", "name": "_percent", "type": "uint256" }], "name": "addPlan", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "_user", "type": "address" }], "name": "deactivateUserPlan", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "string", "name": "subId", "type": "string" }], "name": "deactivePlan", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "_user", "type": "address" }], "name": "flashLoanRefInfo", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }, { "internalType": "uint256", "name": "", "type": "uint256" }, { "internalType": "address", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "fundReceiver", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "owner", "outputs": [{ "internalType": "address payable", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "", "type": "address" }], "name": "parent", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "_fundReciever", "type": "address" }], "name": "setFundReciever", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "string", "name": "subId", "type": "string" }, { "internalType": "address", "name": "_referrer", "type": "address" }], "name": "subscribe", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "string", "name": "", "type": "string" }], "name": "subscribtions", "outputs": [{ "internalType": "string", "name": "name", "type": "string" }, { "internalType": "uint256", "name": "feeAmount", "type": "uint256" }, { "internalType": "uint256", "name": "flashloanLimit", "type": "uint256" }, { "internalType": "uint256", "name": "profitMax", "type": "uint256" }, { "internalType": "uint256", "name": "validity", "type": "uint256" }, { "internalType": "address", "name": "acceptedToken", "type": "address" }, { "internalType": "bool", "name": "isActive", "type": "bool" }, { "internalType": "uint256", "name": "refPercent", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address payable", "name": "_newOwner", "type": "address" }], "name": "transferOwnership", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "", "type": "address" }], "name": "users", "outputs": [{ "internalType": "string", "name": "subscribeId", "type": "string" }, { "internalType": "uint256", "name": "balance", "type": "uint256" }, { "internalType": "uint256", "name": "validTill", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "token", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "withdrawFees", "outputs": [], "stateMutability": "nonpayable", "type": "function" }]
// export const BUYTOKENADDRESS = "0x54C09A5856B08D795079cB1Ca61f55afD85Be39a"


export const CHAINS = [

  // {
  //   NAME: "BSC-TEST",
  //   RPC_URL: "https://data-seed-prebsc-1-s1.binance.org:8545/", // BSC TESTNET
  //   CHAIN_ID: 97,

  //   BUYCONTRACTADDRESS: "0x9521894e01D84e098329c22F2f283FF13396FA0d",
  //   BUYTOKENADDRESS: "0x54C09A5856B08D795079cB1Ca61f55afD85Be39a",


  //   ROUTER: "0x1F0929D79d2e992C31dD70A637C33e4a8440d3b0",
  //   TOKENADDRESS: "0x3F1c44C8b7e672674Ee9faE3B96cB3B14F034d72", // DITMAX Token
  //   // MASTERCHEF: "0xA1Ad9d32096693f66091e02c7155E09E84F8f70f",
  //   MASTERCHEF: "0x62404d901467494eC5995CD279b7F8b30AfFf751",
  //   NATIVE: "0x00A0aa653F4230075cE6e9f116188ac0fb36637B",
  //   IMAGE: Images.bin
  // },


  // {
  //   NAME: "Polygon Amoy Testnet",
  //   RPC_URL: "https://api.zan.top/polygon-amoy",
  //   CHAIN_ID: 80002,

  //   BUYCONTRACTADDRESS: "0x70F538bcbB932743a867bC665798A60884AcC971",
  //   BUYTOKENADDRESS: "0xbaf8ef2bbD9db2a2B7D69b5017D5c29bdB561E5F",

  //   TOKENADDRESS: "0x9433f3BaAE2984C6F5C8DE6989aB6dee23eaEE17",
  //   MASTERCHEF: "0x74962D8c90dCb1e4761DF94115BE449044179e5A", // new
  //   // MASTERCHEF: "0x1afd408a544e901af55cB8735d8c6B49c47A11b2",//old
  //   NATIVE: "0x00A0aa653F4230075cE6e9f116188ac0fb36637B",
  //   IMAGE: Images.polygon
  // },

  // {
  //   NAME: "BSC-MAINNET",
  //   RPC_URL: "https://bsc-dataseed1.binance.org/",
  //   CHAIN_ID: 56,

  //   BUYCONTRACTADDRESS: "0x3307D92eFa85435F39EbC209D52899282694cc47",
  //   BUYTOKENADDRESS: "0x55d398326f99059fF775485246999027B3197955",

  //   TOKENADDRESS: "0x9eeB6c5ff183E6001c65a12D70026b900AE76781",
  //   MASTERCHEF: "0x825A21c5A32d22b1241C7672EC9D04025960f766",
  //   NATIVE: "0x00A0aa653F4230075cE6e9f116188ac0fb36637B",
  //   IMAGE: Images.bin
  // },

  {
    NAME: "Polygonn",
    RPC_URL: "https://polygon-bor-rpc.publicnode.com",
    CHAIN_ID: 137,
    BUYCONTRACTADDRESS: "0x8E26281608e4eD7f23dF7a5BCCAcb11fe0e3F503",//"0x9c739186913A1E4a6fe98173a68CFcBfABF35f1d",
    BUYTOKENADDRESS: "0xc2132D05D31c914a87C6611C10748AEb04B58e8F",
    TOKENADDRESS: "0x9433f3BaAE2984C6F5C8DE6989aB6dee23eaEE17",
    MASTERCHEF: "0x74962D8c90dCb1e4761DF94115BE449044179e5A", // new
    // MASTERCHEF: "0x1afd408a544e901af55cB8735d8c6B49c47A11b2",//old
    NATIVE: "0x00A0aa653F4230075cE6e9f116188ac0fb36637B",
    IMAGE: Images.polygon
  },









];
